/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})
// export default instance;

// export async function dowloadFile(){
//   return await instance.get('/api/v1/board/faq').then((response) => {
//     return response.data.content.url;
//   })
// }

// eslint-disable-next-line consistent-return
export async function dowloadFile() {
  const apiUrl = '/api/v1/client-file'

  try {
    const response = await instance.get(apiUrl)
    const { url } = response.data.content

    // console.log(response);
    // console.log(url);
    return url
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}
// export{
//   loadfaq
// }
